import { render, staticRenderFns } from "./DuplicateForm.vue?vue&type=template&id=d8c9364a&"
import script from "./DuplicateForm.vue?vue&type=script&lang=js&"
export * from "./DuplicateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports